<div class="up-coming-events rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="title-area-center-style">
          <h2 class="title">Formas de Ingresso</h2>
          <p class="post-title">
            Escolha como quer começar a tornar seu sonho realidade.
          </p>
        </div>
      </div>
    </div>
    <div class="row mt--50 mb-5">
      <div
        class="col-lg-6"
        *ngFor="let forma of formasDeIngresso; let i = index"
        [ngClass]="{ 'mt--50': i >= 2 }"
      >
        <div class="upcoming-events-main-wrapper-1">
          <div class="single-upcoming-events">
            <div class="img-information">
              <div class="information">
                <a [href]="forma.link">
                  <h5 class="title">{{ forma.titulo }}</h5>
                </a>
                <div class="date-details">{{ forma.descricao }}</div>
                <a [href]="forma.link" class="rts-btn btn-primary with-arrow">
                  Saiba mais <i class="fa-solid fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
